
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  CostLabor,
  CostsApi,
  ValidationProblemDetails,
  Workorder
} from 'performo-api';

import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    api: 'costsApi'
  })
})
export default class UpdateCostLabor extends Vue {
  @Prop({ required: true })
  private labor!: CostLabor;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  private popoverOpen = false;
  private loading = false;

  private api!: CostsApi;

  private editedItem: CostLabor = {
    laborDate: this.labor.laborDate,
    laborHours: this.labor.laborHours,
    laborName: this.labor.laborName,
    tcardNotes: this.labor.tcardNotes
  };

  private async editLabor() {
    if (this.labor.costId && this.editedItem.laborDate) {
      try {
        this.loading = true;
        var editedLaborResponse = await this.api.editLaborById({
          costId: this.labor.costId,
          costLaborEditCommand: {
            costId: this.labor.costId,
            laborHours: this.editedItem.laborHours,
            workorderId: this.labor.workorderId,
            laborDate: new Date(
              this.editedItem.laborDate.getTime() -
                this.editedItem.laborDate.getTimezoneOffset() * 60000
            ),
            tcardNotes: this.editedItem.tcardNotes
          }
        });
        this.$emit('labor-updated', editedLaborResponse);
      } catch (error) {
        this.errorHandler(error as ValidationProblemDetails);
      }
      this.loading = false;
      this.popoverOpen = false;
    }
  }

  private async cancelLabor() {
    this.editedItem.laborName = this.labor.laborName;
    this.editedItem.laborHours = this.labor.laborHours;
    this.editedItem.laborDate = this.labor.laborDate;
    this.editedItem.tcardNotes = this.labor.tcardNotes;

    this.popoverOpen = false;
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    this.$emit('error', error);
  }

  get clientSideValidation() {
    return (
      this.editedItem.laborName &&
      this.editedItem.laborHours &&
      this.editedItem.laborHours > 0 &&
      this.editedItem.laborDate
    );
  }

  private calculateLaborDate(inputDate: Date) {
    var dateAdjustedForUTC = new Date(
      inputDate.getUTCFullYear(),
      inputDate.getUTCMonth(),
      inputDate.getUTCDate()
    );
    return dateAdjustedForUTC;
  }
}
